import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../../environments/environment';
import { IEms } from '../models/ems';

@Injectable({
  providedIn: 'root',
})
export class Ems {
  private baseUrl: string = `${environment.apiUrl}/ems`;
  private http: HttpClient = inject(HttpClient);

  //signals for state
  emsList = signal<IEms[]>([]);
  isLoading = signal(false);
  errorMessage = signal('');

  getEMSList(controllerId: number): void {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.http
      .get<IEms[]>(`${this.baseUrl}/controller/${controllerId}`)
      .subscribe({
        next: (data) => {
          this.emsList.set(data);
          this.isLoading.set(false);
        },
        error: (err) => {
          console.error(err);
          this.errorMessage.set('Failed to load EMSList.');
          this.isLoading.set(false);
        },
      });
  }

  updateFromSocket(data: IEms[]) {
    this.emsList.set(data);
  }
}
